module.exports = __webpack_public_path__ + "media/images/workplace/activity_points/display_name_icon-78705e114661500c57d521ee64bdd2a7.png";